<template>
    <div :class="{ list1: true, ignore: true, down: tabName }" @mouseleave="closePop">
        <div :class="{ cont: tabName, fgkj: tabName == 'fgkj', fwzc: tabName == 'fwzc', gywm: tabName == 'gywm' }">
            <div class="tab" :ref="tabName" :style="{ transform: `translateX(${offsetX}px)` }">
                <div @mouseenter="handleMouseEnter(i.name)" @mouseleave="handleMouseLeave" v-for="i in list"
                    :key="i.name">
                    <div :class="{ active: activeName == i.name }">
                        <span  v-if="tabName == 'ddsl' || tabName == 'ddsh'">{{ i.name }}</span>
                        <a v-else @click="e => goPage(i.path, tabName, i.id, e)" :href="menuHref(i)">{{ i.name }}</a>
                    </div>
                </div>
            </div>
            <div class="des" v-if="tabName == 'ddsl' || tabName == 'ddsh'">
                <div v-show="activeName == i.name" class="txt" v-for="i in list" :key="i.name">{{ i.intro }}</div>
                <a :href="getHref({ path: '/types' })" v-if="tabName == 'ddsl'" class="all" @click="e => goType('/types', e)">
                    <img src="@/assets/img/s.png" alt="">
                    <span>All Models</span>
                </a>
            </div>
            <div ref="carlist" :class="{ carlist: true, cont: tabName == 'ddsl' }"
                :style="{ height: tabName == 'ddsl' ? height : 0 }">
                <div class="car" v-show="i.name == activeName" v-for="i in ddsl" :key="i.name">
                    <div v-for="a in i.list" :key="a.id">
                        <span>{{ a.line_name }}</span>
                        <a :href="getHref({ path: '/show', query: { id: item.id, op: 3 } })" class="carinfo carinfo2"
                            v-for="(item, d) in a.products" :key="d" @click="event => goShow('/show', item.id, 3, event)">
                            <div class="lImg" target="_blank">
                                <img v-if="i.name == activeName || getImg.includes(i.name)" :src="item.img" alt="" />
                            </div>
                            <span>{{ item.name }}</span>
                        </a>
                    </div>
                </div>
            </div>
            <div ref="carlist2" v-show="tabName == 'ddsh'" :class="{ carlist: true, cont: tabName == 'ddsh' }"
                :style="{ height: tabName == 'ddsh' ? height : 0 }">
                <div class="car" v-show="i.name == activeName" v-for="i in ddsh" :key="i.name">
                    <div v-for="a in i.list" :key="a.id">
                        <span>{{ a.line_name }}</span>
                        <a :href="getHref({ path: '/show', query: { id: item.id, op: 3 } })" class="carinfo carinfo2"
                            v-for="(item, d) in a.products" :key="d" @click="event => goShow('/show', item.id, 3, event)">
                            <div class="lImg" target="_blank">
                                <img v-if="i.name == activeName || getImg.includes(i.name)" :src="item.img" alt="" />
                            </div>
                            <span>{{ item.name }}</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div
            :class="{ cont: tabName && tabName!='ddsl', }">
            <div class="tab">
                <div @mouseenter="getName(i.name)" @click="goPage(i.path)" v-for="i in list" :key="i.name">
                    <div :class="{ active: activeName == i.name }">{{ i.name }}</div>
                </div>
            </div>
        </div> -->

    </div>
</template>

<script>
// import ImgSwitch from './ImgSwitch.vue'
export default {
    name: 'headerMenu',
    components: {
        // ImgSwitch,
    },
    data() {
        return {
            activeName: '',
            offsetX: '',
            list: '',
            hoverTimer: null,
            getImg: [],
            hoverDelay: 200 // 200ms后触发，根据需要调整
        }
    },
    props: {
        tabName: {
            type: String
        },
    },
    computed: {
        height() {
            if (!this.list || !this.activeName) return '0px'

            const activeGroup = this.list.find(i => i.name == this.activeName)
            if (!activeGroup || !activeGroup.list || !activeGroup.list.length) return '0px'

            const estimatedHeight = activeGroup.list.reduce((total, line) => {
                const productCount = Array.isArray(line.products) ? line.products.length : 0
                const rows = Math.max(1, Math.ceil(productCount / 4))
                return total + 40 + rows * 210
            }, 0)

            const boundedHeight = Math.max(240, Math.min(estimatedHeight, 560))
            return `min(${boundedHeight}px, calc(100vh - 190px))`
        },
        ddsl() {
            return this.$store.state.menuList.ddsl
        },
        ddsh() {
            return this.$store.state.menuList.ddsh
        },
        fgkj() {
            return this.$store.state.menuList.fgkj
        },
        fwzc() {
            return this.$store.state.menuList.fwzc
        },
        gywm() {
            return this.$store.state.menuList.gywm
        },
    },
    watch: {
        tabName(n) {
            if (n) {
                this.list = this[n]
                if (n == 'ddsl' || n == 'ddsh') {
                    this.activeName = this.list[0].name
                    this.offsetX = 0
                } else {
                    this.$nextTick(() => {
                        const namesWidth = this.$refs[n].offsetWidth;
                        const rootStyle = window.getComputedStyle(this.$el)
                        const padding = parseFloat(rootStyle.paddingLeft) || 0
                        const availableWidth = Math.max(0, this.$el.clientWidth - padding * 2)
                        const menuRect = this.$store.state.offset[n]
                        const preferredOffset = menuRect.left + (menuRect.width / 2) - (namesWidth / 2) - padding
                        const maxOffset = Math.max(0, availableWidth - namesWidth)
                        this.offsetX = Math.min(Math.max(0, preferredOffset), maxOffset)
                    })

                }

            }
        },
        activeName: {
            immediate: true,
            handler(n) {
                if (this.$refs.carlist) {
                    this.$refs.carlist.scrollTop = 0;
                }
                if (this.$refs.carlist2) {
                    this.$refs.carlist2.scrollTop = 0;
                }
                if (!this.getImg.includes(n) && n) {
                    this.getImg.push(n)


                }
            }
        }
    },
    mounted() {
    },
    methods: {

        goShow(url, id, op, e) {
            e.preventDefault();
            window.scrollTo({
                top: 0,
                behavior: 'smooth' // 平滑滚动
            });
            if (url) {
                this.$router.push({
                    path: url,
                    query: {
                        id, op
                    }
                })
                this.$emit('close')
            }
        },

        goType(url, e) {
            e.preventDefault()
            this.$router.push(url)
            this.$emit('close')
        },
        goPage(url, name, id, e) {
            e.preventDefault()
            window.scrollTo({
                top: 0,
                behavior: 'smooth' // 平滑滚动
            });
            if (url == this.$route.path) {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth' // 平滑滚动
                });
            }

            if (name == 'ddsl' || name == 'ddsh') return
            // 富贵科技
            if (name == 'fgkj') {
                this.$router.push({
                    path: '/show',
                    query: {
                        id, op: 2
                    }
                })
                this.$emit('close')
                return
            }

            // // 服务支持
            if (name == 'fwzc') {
                if (url == '/afterSale' || url == '/guide') {
                    this.$router.push(url)
                    this.$emit('close')
                } else {
                    this.$router.push({
                        path: '/show',
                        query: {
                            id, op: 6
                        }
                    })
                    this.$emit('close')
                    return
                }
            }

            if (name == 'gywm') {
                if (url == '/aboutUs' || url == '/news' || url == '/contactUs' || url == '/jobIndex') {
                    this.$router.push(url)
                    this.$emit('close')
                } else {
                    this.$router.push({
                        path: '/show',
                        query: {
                            id, op: 7
                        }
                    })
                    this.$emit('close')
                    return
                }
            }

            // this.$router.push(url)
            // this.$emit('close')

        },
        handleMouseEnter(name) {
            // 清除之前的定时器（防止快速悬停多次触发）
            if (this.hoverTimer) clearTimeout(this.hoverTimer)

            // 设置新的定时器
            this.hoverTimer = setTimeout(() => {
                this.getName(name)
            }, this.hoverDelay)
        },
        handleMouseLeave() {
            // 鼠标离开时清除定时器（防止未达到时间就离开仍然触发）
            if (this.hoverTimer) {
                clearTimeout(this.hoverTimer)
                this.hoverTimer = null
            }
        },
        getName(name) {

            this.activeName = name
        },
        getHref(route) {
            const resolved = this.$router.resolve(route);
            return resolved.href;
        },
        menuHref(item) {
            if (this.tabName === 'gywm' && ['/aboutUs', '/news', '/contactUs', '/jobIndex'].includes(item.path)) {
                return this.getHref(item.path)
            }
            return this.getHref({
                path: '/show',
                query: {
                    id: this.tabName === 'gywm' ? (item.id || 0) : item.id,
                    op: this.tabName === 'fgkj' ? 2 : this.tabName === 'fwzc' ? 6 : 7
                }
            })
        },

        closePop() {
            this.list = []
            this.activeName = ''
            this.$emit('close')
        }
    }
}
</script>

<style lang="scss" scoped>
.list1.ignore {
    width: 100%;
    box-sizing: border-box;
    position: fixed;
    top: 72px;
    max-height: 0;
    left: 0;
    padding: 0 clamp(28px, 9vw, 180px);
    background: #fff;
    z-index: 98;
    transition: max-height 0.35s ease, opacity 0.25s ease;
    overflow: hidden;
    opacity: 0;

    >div {
        opacity: 0;
        max-height: 0;
        transition: max-height 0.5s ease, opacity 0.5s ease;
    }
    &.down {
        max-height: calc(100vh - 72px);
        opacity: 1;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);

        .cont {
            opacity: 1;
            max-height: calc(100vh - 72px);

            &::-webkit-scrollbar {
                width: 0 !important;
            }
        }
    }

    .tab {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: clamp(6px, 1vw, 20px);
        padding: 18px 0 12px;
        font-weight: 400;
        font-size: clamp(13px, 0.9vw, 16px);
        color: #000000;
        transition: none;

        >div {
            min-width: 0;
            margin: 0;
            white-space: nowrap;
            cursor: pointer;

            >div {
                padding: 6px clamp(7px, 0.7vw, 13px);
            }

            a {
                text-decoration: none;
                color: #000000;
            }

            .active {
                border-radius: 15px;
                background-color: #f5f3f3;

                a,
                span {
                    color: #B00D16 !important;
                }
            }
        }
    }

    .des {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 24px;
        min-height: 44px;
        padding-bottom: 14px;

        .txt {
            flex: 1 1 auto;
            min-width: 0;
            font-weight: 400;
            font-size: clamp(13px, 0.9vw, 16px);
            color: #757575;
        }

        .all {
            flex: 0 0 auto;
            cursor: pointer;
            display: flex;
            align-items: center;
            font-weight: 500;
            font-size: 15px;
            color: #B00D16;
            text-decoration: none;

            img {
                width: 21px;
                height: 21px;
                margin-right: 6px;
            }
        }
    }

    .carlist {
        overflow-y: auto;
        overscroll-behavior: contain;
        padding-right: 6px;

        .car>div {
            display: flex;
            align-items: flex-start;
            flex-wrap: wrap;
            column-gap: clamp(18px, 2vw, 40px);
            padding-bottom: 18px;

            >span {
                display: block;
                width: 100%;
                min-height: 20px;
                margin-bottom: 8px;
                font-weight: 700;
                font-size: 16px;
                line-height: 20px;
                color: #000000;
            }

            .carinfo {
                width: 200px;
                height: 200px;
                margin-bottom: 24px;
                padding: 0 15px 10px;
                overflow: hidden;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                flex: 0 0 200px;
                cursor: pointer;
                font-weight: 400;
                font-size: 16px;
                color: #010202;
                border-radius: 10px;
                text-decoration: none;

                &:hover {
                    background-color: #f1f1f1;
                }

                span {
                    max-width: 100%;
                    margin-top: 8px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }

            .carinfo2 .lImg {
                width: 200px;
                height: 160px;
                display: flex;
                align-items: center;
                justify-content: center;

                ::v-deep img {
                    height: 140px;
                    max-width: 200px;
                    width: auto;
                    object-fit: contain;
                }
            }
        }
    }

    .fgkj .tab,
    .fwzc .tab,
    .gywm .tab {
        width: max-content;
        justify-content: flex-start;

        >div {
            margin: 0 16px;
        }
    }

    @media screen and (max-width: 1200px) {
        padding-right: 28px;
        padding-left: 28px;

        .tab {
            gap: 4px;
            font-size: 13px;

            >div>div {
                padding: 5px 7px;
            }
        }

        .carlist .car>div {
            column-gap: 16px;
        }
    }
}
</style>
